import { render, staticRenderFns } from "./SummaryOccuranceList.vue?vue&type=template&id=544234e4&"
import script from "./SummaryOccuranceList.vue?vue&type=script&lang=js&"
export * from "./SummaryOccuranceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports